var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bid == 1)?_c('taProjectDetails1',{attrs:{"pulldata":_vm.data}}):(_vm.bid == 2)?_c('taProjectDetails2',{attrs:{"pulldata":_vm.data}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }